module.exports = __webpack_public_path__ + "img/pay-union-pay.04578a63.svg";